import template from './time-picker.html';

let TimePickerDirective = [() => {
  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      isRequired: '=ngRequired',
      ngChange: '=',
      displayTimeFormat: '=',
      isMeridian: '=',
      showSeconds: '=',
      showSpinners: '=',
      showFullTime: '=',
      hideHours: '<',
      tab: '@'
    },
    template,
    link: function (scope, element, attrs) {
      scope.displayTime = '';
      scope.allowOnce = true;

      if (scope.hideHours === undefined) {
        scope.hideHours = false;
      }

      scope.$watch('ngModel', function(newValue, oldValue) {
        const spanElement = element.find("span.time-picker-value");
        spanElement.removeClass('ng-invalid ng-valid');

        if(!scope.ngModel) {
          spanElement.addClass(scope.isRequired ? 'ng-invalid' : 'ng-valid');
          scope.displayTime = null;
          return;
        }

        spanElement.addClass('ng-valid');

        let
        hour = (scope.displayTimeFormat || scope.displayTimeFormat === undefined) ? scope.ngModel.getHours()-(scope.ngModel.getHours() >= 12 ? 12 : 0) : scope.ngModel.getHours(),
        minutes = scope.ngModel.getMinutes(),
        seconds = scope.ngModel.getSeconds(),
        period = scope.ngModel.getHours() >= 12 ? 'PM' : 'AM';

        hour = (hour < 10 ? '0' : '') + hour;
        minutes = (minutes < 10 ? '0' : '') + minutes;
        seconds = (seconds < 10 ? '0' : '') + seconds;

        if (scope.hideHours && ['route'].includes(scope.tab)) {
          scope.displayTime = minutes + ':' + seconds;
        }
        else if ((scope.displayTimeFormat || scope.displayTimeFormat === undefined) && !scope.showSeconds) {
          scope.displayTime = hour + ':' + minutes + ' ' + period;
        }
        else if (scope.showSeconds) {
          scope.displayTime = (scope.showFullTime ? hour : '00') + ':' + minutes + ':' + seconds;
        }
        else {
          scope.displayTime = hour + ':' + minutes
        }
      });

      scope.clear = function() {
        scope.ngModel = null;
        scope.allowOnce = true;
      };

      scope.setAllowOnceValue = function () {
        if (scope.ngModel) scope.allowOnce = false;
      };

      scope.handleTimeChange = function () {
        if (!scope.allowOnce) return;
        let dt = new Date(scope.ngModel).setSeconds('00');
        scope.ngModel = new Date(dt);
      }
    }
  }
}]

export default TimePickerDirective;


// WEBPACK FOOTER //
// ./client/app/common/ui/time-picker/time-picker.directive.js